var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"nav-item",attrs:{"active-class":"nav-item-active","to":{ name: _vm.route },"exact":_vm.exact},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_c('p',{staticClass:"nav-item-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }